import React from 'react';
import pt from 'prop-types';
import styles from '../_pages/PreviousImages/v2/PreviousImages.module.scss';
import PreviewImage from '../PreviewImage';
import { formattedSeason } from '../../utils/functions';
import Button from '../Button/v2';

// Define the static URL for the Blossom background
const BLOSSOM_BACKGROUND_URL = "https://shoobphoto.s3.amazonaws.com/images/backgrounds/Blossom.jpg?1708019982";

export default function PastImageItem({ onClick, student, pricelist, studentImage }) {
  
  // 1. Check the condition: does the folder include 'spring' (case-insensitive)?
  const isSpring = studentImage.folder.toLowerCase().includes('spring');

  const folderString = studentImage.folder;
  const parts = folderString.split(' '); // ['Fall', '2021']
  const yearString = parts[parts.length - 1]; // '2021'

  // If you need the year as a number:
  const yearNumber = parseInt(yearString, 10); // 2021

  const gradeToDisplay = isSpring ? student.grade - 1 : student.grade - 2;   // Logic for NON-Spring (Original Grade)
  
  // 2. Determine the background URL based on the condition
  const backgroundUrl = isSpring
    ? BLOSSOM_BACKGROUND_URL // Use Blossom if 'spring' is found
    : pricelist.defaultBackgroundUrl; // Otherwise, use the default from the pricelist

  return (
    <>
    {studentImage.watermarkUrl && (
    <div className={styles.pastImage}>

      <PreviewImage
        foregroundUrl={studentImage.watermarkUrl || studentImage.imageUrl}
        // Use the conditionally determined backgroundUrl
        backgroundUrl={backgroundUrl} 
        isPreviewHidden={false}
      />
      <p>{formattedSeason(studentImage.folder)}</p>
      <Button onClick={onClick} type="button">Select</Button>
    </div>
    )}
    </>
  );
}

PastImageItem.defaultProps = {
  onClick: () => {},
};

PastImageItem.propTypes = {
  onClick: pt.func,
  pricelist: pt.shape({
    id: pt.number.isRequired,
    defaultBackgroundUrl: pt.string.isRequired,
  }).isRequired,
  studentImage: pt.shape({
    folder: pt.string.isRequired,
    imageUrl: pt.string.isRequired,
    watermarkUrl: pt.string.isRequired,
  }).isRequired,
};